module.exports = __webpack_public_path__ + "static/img/weixin_icon.6f9b52b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/weixin_icon.png
// module id = ++VC
// module chunks = 1